

export const getPagination = ({pageSize, page}) => {
  const _page = parseInt(page || 1, 10)
  const start = (_page - 1) * pageSize
  return {
    start,
    page: _page
  }
}